/* __next_internal_client_entry_do_not_use__ Group auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1519))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.760Z
 */ export var Group = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M4.71436 5.57144C4.71436 6.07796 4.81412 6.57953 5.00796 7.0475C5.2018 7.51547 5.48592 7.94068 5.84409 8.29885C6.20226 8.65702 6.62746 8.94113 7.09543 9.13497C7.5634 9.32881 8.06497 9.42858 8.5715 9.42858C9.07803 9.42858 9.57959 9.32881 10.0476 9.13497C10.5155 8.94113 10.9407 8.65702 11.2989 8.29885C11.6571 7.94068 11.9412 7.51547 12.135 7.0475C12.3289 6.57953 12.4286 6.07796 12.4286 5.57144C12.4286 5.06491 12.3289 4.56334 12.135 4.09537C11.9412 3.6274 11.6571 3.20219 11.2989 2.84403C10.9407 2.48586 10.5155 2.20174 10.0476 2.0079C9.57959 1.81406 9.07803 1.71429 8.5715 1.71429C8.06497 1.71429 7.5634 1.81406 7.09543 2.0079C6.62746 2.20174 6.20226 2.48586 5.84409 2.84403C5.48592 3.20219 5.2018 3.6274 5.00796 4.09537C4.81412 4.56334 4.71436 5.06491 4.71436 5.57144V5.57144Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.2855 22.2857H0.856934V19.7143C0.856934 17.6683 1.66969 15.7062 3.1164 14.2595C4.5631 12.8128 6.52526 12 8.57122 12C10.6172 12 12.5793 12.8128 14.026 14.2595C15.4728 15.7062 16.2855 17.6683 16.2855 19.7143V22.2857Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M14.5371 1.81715C14.8293 1.74882 15.1284 1.7143 15.4285 1.71429C16.4515 1.71429 17.4326 2.12067 18.156 2.84403C18.8793 3.56738 19.2857 4.54846 19.2857 5.57144C19.2857 6.59442 18.8793 7.57549 18.156 8.29885C17.4326 9.0222 16.4515 9.42858 15.4285 9.42858C15.1519 9.42848 14.8761 9.39918 14.6057 9.34115",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M17.1016 12.1818C18.8154 12.5625 20.348 13.5165 21.4464 14.886C22.5448 16.2555 23.1431 17.9588 23.1427 19.7143V22.2858H19.7141",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "Group", {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
